// extracted by mini-css-extract-plugin
module.exports = {"dzMessage":"filesDropdown_dzMessage__3kL42","dzSubtitle":"filesDropdown_dzSubtitle__2BY46"};